import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_DEPARTMENT, ADD_DEPARTMENT_FAILED, ADD_DEPARTMENT_SUCCESS, DEPARTMENT, DEPARTMENT_FAILED, DEPARTMENT_SUCCESS, UPDATE_DEPARTMENT, UPDATE_DEPARTMENT_FAILED, UPDATE_DEPARTMENT_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getDepartments = () => async (dispatch) => {
  dispatch({
    type: DEPARTMENT,
  });
  try {
    let response = await api(`department/departmentList`, "get", {}, getAuthHeader());
    dispatch({
      type: DEPARTMENT_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Department list error ====>", error);
    return dispatch({
      type: DEPARTMENT_FAILED,
      payload: error?.message,
    });
  }
};

export const addDepartment = (data) => async dispatch => {
  dispatch({
    type: ADD_DEPARTMENT
  })
  try {
    let response = await api(`department/add`, 'post', data, getAuthHeader())
    console.log('add department data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_DEPARTMENT_SUCCESS,
      payload: response?.data
    })
    await dispatch(getDepartments());
    return response
  } catch (error) {
    console.log("while Adding department error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_DEPARTMENT_FAILED,
      payload: error?.message
    })
  }
}

export const updateDepartment = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_DEPARTMENT
  })
  try {
    let response = await api(`department/update/${id}`, 'put', data, getAuthHeader())
    console.log('update department data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_DEPARTMENT_SUCCESS,
      payload: response?.data
    })
    await dispatch(getDepartments());
    return response
  } catch (error) {
    console.log("while updating department error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_DEPARTMENT_FAILED,
      payload: error?.message
    })
  }
}